<template>
  <div class="wrapper">
    <slot name="toggle" v-if="!!$slots.toggle || useDefaultToggle">
      <Icon
        class="toggle"
        :icon="isVisible ? 'chevron-up' : 'chevron-down'"
        @click="$emit('toggle')"
      />
    </slot>
    <transition :name="inverted ? 'slide-up' : 'slide-down'">
      <div v-if="isVisible" class="content-section">
        <slot>Default content to slide...</slot>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import Icon from "@/components/shared/Icon.vue";

const props = withDefaults(
  defineProps<{ isVisible: boolean; inverted?: boolean; useDefaultToggle?: boolean }>(),
  {
    inverted: false,
    name: "slide-down",
    useDefaultToggle: false,
    isVisible: false,
  },
);
</script>

<style scoped>
.content-section {
  overflow: hidden;
  transition: all 0.4s ease-out;
}

/* --- Slide Down Animations --- */
.slide-down-enter-from,
.slide-down-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-20px);
}

.slide-down-enter-to,
.slide-down-leave-from {
  max-height: 200px; /* Adjust based on content */
  opacity: 1;
  transform: translateY(0);
}

/* --- Slide Up Animations --- */
.slide-up-enter-from,
.slide-up-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(20px);
}

.slide-up-enter-to,
.slide-up-leave-from {
  max-height: 200px;
  opacity: 1;
  transform: translateY(0);
}
</style>
